import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators  } from 'redux';
import localforage from 'localforage';
import moment from 'moment';

import './RoomPickerModal.css';

import * as sessionActions from '../actions/session-actions.js';
import RoomPickerCell from './RoomPickerCell.js';

class RoomPickerModal extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.clickedRoom = this.clickedRoom.bind(this);
    this.renderRooms = this.renderRooms.bind(this);
    this.clickedNewRoom = this.clickedNewRoom.bind(this);

    this.state = {
      roomInput: '',
      rooms: []
    };
  }

  handleInputChange(ev) {
    const { target } = ev;
    const { value } = target;

    this.setState({ roomInput: value });
  }

  componentDidMount() {
    // Autofocus the room input field.
    this.roomInput.focus();

    // Grab recent rooms from local app data.
    localforage.getItem('data')
      .then(({ recentRooms }) => {
        if (recentRooms) {
          this.setState({ rooms: recentRooms });
        }
      })
  }

  /**
   * Whether or not the modal has an inputted value for the
   * room name filtering/creation.
   * @public
   * @returns {Boolean} Whether or not we have an input value.
   */
  hasRoomInput() {
    const { roomInput } = this.state;
    return !!roomInput;
  }

  /**
   * The click handler that gets called when a RoomPickerCell gets clicked.
   *
   * @public
   * @param {Object} room The room object that was clicked.
   */
  clickedRoom(room) {
    console.debug('Clicked room:', room);
    this.props.actions.requestRoomChange(room.name);
    this.props.finish();
  }

  /**
   * Clicked the cell to create a new room with the current roomInput
   * value.
   *
   * @public
   * @memberOf RoomPickerModal
   */
  clickedNewRoom() {
    const { roomInput } = this.state;
    this.props.actions.requestRoomChange(roomInput.trim());
    this.props.finish();
  }

  /**
   * Render out the filtered list of rooms, conditionally including
   * the "Create room" cell.
   *
   * @public
   * @returns [Object] The list of <li> items to render with RoomPickerCells.
   */
  renderRooms() {
    let { rooms, roomInput } = this.state;
    rooms = [
      {
        id: 0,
        name: 'Lobby',
        lastJoined: new Date()
      },
      ...rooms
    ];

    let filteredRooms = rooms.slice();
    if (roomInput) {
      // TODO: We should be smarter with this filtering and instead
      // see if there are any substring matches of the given roomInput
      // value within the room name.
      filteredRooms = filteredRooms.filter((room) => {
        return room.name.toLowerCase().startsWith(roomInput.toLowerCase());
      });
    }

    // Compile the list of cells. Map through each filtered room object,
    // create a formatted description (with overrides for rooms named "Lobby"),
    // and wrap it in an <li>.
    let cells = [];
    cells = filteredRooms.map((room) => {
      let lastJoined = moment(room.lastJoined);
      let roomDescription = `Last joined ${lastJoined.fromNow()}`;
      if (room.name === 'Lobby') {
        roomDescription = 'The default room of Normal Chat!';
      }

      return (<li key={room.name} role="presentation">
        <RoomPickerCell room={room} name={room.name} description={roomDescription} onClick={this.clickedRoom} />
      </li>);
    });

    // Generate a list of the room names currently being shown, used to conditionally show
    // the "Create a room" cell (below).
    let roomNames = filteredRooms.map((room) => room.name);

    // If we have an input value, and the input value doesn't match any of the names in
    // `roomNames`, show the cell offering to create it.
    if (roomInput && !roomNames.find((name) => name.toLowerCase() === roomInput.toLowerCase())) {
      cells.push(<li key="createdRoom" role="presentation">
        <div className="RoomPickerCell" onClick={this.clickedNewRoom}>
          <span className="RoomPickerCell__desc"><img src="/assets/img/room-picker-add.svg" className="RoomPickerCell__icon" alt="" />Create a room named "{this.state.roomInput}"</span>
        </div>
      </li>);
    }

    return cells;
  }

  render() {
    let roomHeader;
    if (!this.state.roomInput) {
      roomHeader = <h3 className="RoomPickerModal__recent-header">Recent rooms</h3>
    }

    return (
      <div className="RoomPicker__wrapper">
        <div className="RoomPickerModal__overlay" onClick={this.props.close}></div>
        <div className="RoomPickerModal">
          <input type="text"
            className="RoomPickerModal__input"
            placeholder="Enter a room name..."
            onChange={this.handleInputChange}
            value={this.state.roomInput}
            ref={(input) => { this.roomInput = input; }} />

          <section className="RoomPickerModal__recent">
            {roomHeader}

            <ul className="RoomPickerModal__room-list">
              {this.renderRooms()}
            </ul>
          </section>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch)
  };
};

export default connect(null, mapDispatchToProps)(RoomPickerModal);



// WEBPACK FOOTER //
// ./src/components/RoomPickerModal.js